import store from 'store';
import { AppointmentsDetailReportDto } from './AppointmentsDetailReportDto';
import { AppointmentDetailReport, AppointmentsDetailReport } from 'model/BookingsReport';
import moment from 'moment';
import { AppointmentDuration } from '@spike/appointment-model';

export const convertToAppointmentsDetailReport = (items: AppointmentsDetailReportDto): AppointmentsDetailReport => {
    const timeZone = store.getState().login.auth.timeZone!;

    const appointmentsReport: AppointmentsDetailReport = {
        items: [],
        pagination: {
            page: Number(items.page),
            pageSize: Number(items.size),
            totalRecords: items.total_records,
            totalPages: items.total_pages
        },
        page: items.page,
        pageSize: items.size,
        totalRecords: items.total_records,
        totalPages: items.total_pages
    };

    items.items?.forEach(item => {
        const duration: AppointmentDuration = {
            from: moment(item.booked_at).tz(timeZone),
            to: moment(item.booking_end_at).tz(timeZone)
        };
        const itemConverted: AppointmentDetailReport = {
            bookingId: item.booking_id,
            dateCreated: item.date_created,
            dateScheduled: item.date_scheduled,
            clientId: item.customer_id,
            clientName: item.customer_name,
            petId: item.pet_id,
            petName: item.pet_name,
            petSize: item.pet_size,
            petHairLength: item.pet_hair_length,
            type: item.type,
            itemName: item.item_name,
            statusId: item.status_id,
            statusName: item.status_name,
            duration: duration,
            staff: item.staff_name,
            createdBy: item.created_by,
            canceledBy: item.canceled_by,
            paid: item.paid,
            netSales: item.net_sales,
            bookedAt: item.booked_at,
            bookingEndAt: item.booking_end_at
        };

        appointmentsReport.items.push(itemConverted);
    });

    return appointmentsReport;
};
